import { ScanItemContent } from '@/features/scans/components/ScanItemContent'
import { useParams } from 'react-router-dom'

export default function ScanItemPage() {
  const { itemId } = useParams()

  return <ScanItemContent itemId={itemId!} />
}
